import React, { useState } from 'react';
import { EditText } from '../../../../component/ui/edit-text/edit-text';
import CallToActionButton from '../../../../component/call-to-action-button/call-to-action-button';
import { updatePollNameOperation } from '../operations/update-poll-name-operation';
import { PollWithQuestionsResponse } from '../../../../api/types/settings/settings-all';

interface EditPollNameDialogProps {
  poll: PollWithQuestionsResponse;
  closeDialog: () => void;
}

export const EditPollNameDialog: React.FC<EditPollNameDialogProps> = ({
  poll,
  closeDialog,
}) => {
  const [pollName, setPollName] = useState(poll.pollName);
  const [loading, setLoading] = useState(false);

  const handleOnSubmit = async () => {
    await updatePollNameOperation(poll.id, pollName, setLoading, closeDialog);
  };

  return (
    <div>
      <EditText
        title={'שם המשוב'}
        onChange={setPollName}
        value={pollName}
        maxLength={100}
      />
      <div style={{ height: '8px' }} />
      <CallToActionButton
        text={'עדכון שם'}
        onClick={handleOnSubmit}
        loading={loading}
      />
    </div>
  );
};
